(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["c-faq"] && !Shopify.designMode) return;
  try {
    
  const syncFaqPanelHeights = (section) => {
    section.querySelectorAll('.c-faq__item.is-open .c-faq__panel-body').forEach((panel) => {
      panel.style.setProperty('--c-faq-panel-height', `${panel.scrollHeight}px`);
    });
  };

  const initFaqSection = (root) => {
    const section = root?.matches?.('.c-faq') ? root : root?.querySelector?.('.c-faq');
    if (!section || section.dataset.faqInit === 'true') return;
    section.dataset.faqInit = 'true';

    const tabs = [...section.querySelectorAll('.c-faq__tab')];
    const panels = [...section.querySelectorAll('.c-faq__panel[data-panel]')];

    if (tabs.length && panels.length) {
      const activateTab = (tab) => {
        const id = tab.dataset.tab;
        tabs.forEach((item) => {
          const active = item === tab;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
          item.tabIndex = active ? 0 : -1;
        });
        panels.forEach((panel) => {
          const active = panel.dataset.panel === id;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });
        requestAnimationFrame(() => syncFaqPanelHeights(section));
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activateTab(tab));
        tab.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            const next = tabs[(index + 1) % tabs.length];
            activateTab(next);
            next.focus();
          } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            const prev = tabs[(index - 1 + tabs.length) % tabs.length];
            activateTab(prev);
            prev.focus();
          }
        });
      });
    }

    section.querySelectorAll('[data-faq-accordion]').forEach((accordion) => {
      accordion.querySelectorAll('.c-faq__trigger').forEach((trigger) => {
        trigger.addEventListener('click', () => {
          const item = trigger.closest('.c-faq__item');
          if (!item) return;

          const isOpen = item.classList.contains('is-open');

          accordion.querySelectorAll('.c-faq__item').forEach((entry) => {
            entry.classList.remove('is-open');
            entry.querySelector('.c-faq__trigger')?.setAttribute('aria-expanded', 'false');
            entry.querySelector('.c-faq__panel-body')?.style.removeProperty('--c-faq-panel-height');
          });

          if (!isOpen) {
            item.classList.add('is-open');
            trigger.setAttribute('aria-expanded', 'true');
            const panel = item.querySelector('.c-faq__panel-body');
            if (panel) {
              panel.style.setProperty('--c-faq-panel-height', `${panel.scrollHeight}px`);
            }
          }
        });
      });
    });

    syncFaqPanelHeights(section);
  };

  initFaqSection(document);
  document.addEventListener('shopify:section:load', (event) => initFaqSection(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-product-list"] && !Shopify.designMode) return;
  try {
    
  const initCPlSlider = (section) => {
    if (!section || section.dataset.cPlReady === 'true') return;

    const track = section.querySelector('.c-pl__track');
    const prevBtn = section.querySelector('.c-pl__nav-btn[data-dir="prev"]');
    const nextBtn = section.querySelector('.c-pl__nav-btn[data-dir="next"]');
    if (!track || !prevBtn || !nextBtn) return;

    section.dataset.cPlReady = 'true';

    const getSlides = () => [...track.querySelectorAll('.c-pl__slide')];

    const getStep = () => {
      const slides = getSlides();
      if (slides.length < 2) return track.clientWidth;
      const a = slides[0].getBoundingClientRect();
      const b = slides[1].getBoundingClientRect();
      return Math.abs(b.left - a.left) || a.width || track.clientWidth;
    };

    const normalizedScroll = () => {
      const dir = getComputedStyle(track).direction === 'rtl' ? -1 : 1;
      return {
        dir,
        pos: track.scrollLeft * dir,
        max: Math.max(0, track.scrollWidth - track.clientWidth),
      };
    };

    const move = (intent) => {
      const { dir } = normalizedScroll();
      const sign = (intent === 'next' ? 1 : -1) * dir;
      track.scrollBy({ left: sign * getStep(), behavior: 'smooth' });
    };

    const updateButtons = () => {
      const { pos, max } = normalizedScroll();
      if (max <= 4) {
        prevBtn.disabled = true;
        nextBtn.disabled = true;
        return;
      }

      prevBtn.disabled = pos <= 4;
      nextBtn.disabled = pos >= max - 4;
    };

    prevBtn.addEventListener('click', () => move('prev'));
    nextBtn.addEventListener('click', () => move('next'));
    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();
  };

  const initAllCPlSliders = (root) => {
    if (!root) return;

    const sections = root.matches?.('[data-c-pl-slider]')
      ? [root]
      : [...root.querySelectorAll('[data-c-pl-slider]')];

    sections.forEach(initCPlSlider);
  };

  initAllCPlSliders(document);
  document.addEventListener('shopify:section:load', (event) => initAllCPlSliders(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-real-reviews"] && !Shopify.designMode) return;
  try {
    
  const pickReelVideoUrl = (button) => button?.dataset?.reelSrc || '';

  const playModalVideo = async (video) => {
    if (!(video instanceof HTMLVideoElement)) return;

    try {
      video.muted = false;
      video.volume = 1;
      await video.play();
    } catch (error) {
      video.controls = true;
    }
  };

  const initCReviews = (root) => {
    const section = root.matches?.('[data-c-reviews]') ? root : root.querySelector?.('[data-c-reviews]');
    if (!section || section.dataset.cReviewsReady === 'true') return;

    const track = section.querySelector('.c-reviews__track');
    const progressBar = section.querySelector('.c-reviews__progress-bar');
    const prevBtn = section.querySelector('.c-pl__nav-btn[data-dir="prev"]');
    const nextBtn = section.querySelector('.c-pl__nav-btn[data-dir="next"]');
    const modal = section.querySelector('[data-c-reels-modal]');
    const modalVideo = modal?.querySelector('.c-reels-modal__video');
    const modalMeta = modal?.querySelector('[data-c-reels-meta]');
    const modalAuthor = modal?.querySelector('[data-c-reels-author]');
    const modalQuote = modal?.querySelector('[data-c-reels-quote]');
    const previewEnabled = section.dataset.cReviewsPreview === 'true';
    if (!track) return;

    section.dataset.cReviewsReady = 'true';

    let previewObserver = null;
    let activePreviewCard = null;
    let previewPlaybackLocked = false;

    const getPreviewCards = () => [...track.querySelectorAll('.c-reel-card--preview')];

    const resetPreviewProgress = (card) => {
      const bar = card?.querySelector('.c-reel-card__preview-progress-bar');
      if (bar) bar.style.width = '0%';
    };

    const updatePreviewProgress = (video, card) => {
      const bar = card?.querySelector('.c-reel-card__preview-progress-bar');
      if (!bar || !video?.duration || !Number.isFinite(video.duration)) return;
      bar.style.width = `${Math.min(100, (video.currentTime / video.duration) * 100)}%`;
    };

    const pauseAllPreviews = () => {
      previewPlaybackLocked = false;
      track.querySelectorAll('.c-reel-card__preview-video').forEach((video) => {
        video.pause();
        const card = video.closest('.c-reel-card');
        card?.classList.remove('is-preview-active');
        resetPreviewProgress(card);
      });
      activePreviewCard = null;
    };

    const playPreviewForCard = (card, { force = false } = {}) => {
      if (!previewEnabled || !card) return;
      const video = card.querySelector('.c-reel-card__preview-video');
      if (!(video instanceof HTMLVideoElement)) return;

      if (!force && activePreviewCard === card && !video.paused && !video.ended) return;

      pauseAllPreviews();
      activePreviewCard = card;
      previewPlaybackLocked = true;
      card.classList.add('is-preview-active');
      video.muted = true;
      video.currentTime = 0;
      resetPreviewProgress(card);
      video.play().catch(() => {
        previewPlaybackLocked = false;
      });
    };

    const isCardVisibleInTrack = (card) => {
      if (!card) return false;
      const trackRect = track.getBoundingClientRect();
      const cardRect = card.getBoundingClientRect();
      return cardRect.right > trackRect.left + 4 && cardRect.left < trackRect.right - 4;
    };

    const playNextPreview = (currentCard) => {
      const cards = getPreviewCards();
      if (!cards.length) return;

      const currentIndex = cards.indexOf(currentCard);
      const nextCard = cards[(currentIndex + 1) % cards.length];
      if (!nextCard || !isCardVisibleInTrack(nextCard)) {
        previewPlaybackLocked = false;
        return;
      }

      playPreviewForCard(nextCard, { force: true });
    };

    const bindPreviewVideoEvents = (card) => {
      const video = card.querySelector('.c-reel-card__preview-video');
      if (!(video instanceof HTMLVideoElement) || video.dataset.previewBound === 'true') return;
      video.dataset.previewBound = 'true';

      video.addEventListener('timeupdate', () => {
        if (activePreviewCard !== card) return;
        updatePreviewProgress(video, card);
      });

      video.addEventListener('ended', () => {
        if (activePreviewCard !== card) return;
        resetPreviewProgress(card);
        playNextPreview(card);
      });
    };

    const initPreviewAutoplay = () => {
      if (!previewEnabled || !('IntersectionObserver' in window)) return;

      const cards = getPreviewCards();
      if (!cards.length) return;

      cards.forEach(bindPreviewVideoEvents);

      previewObserver?.disconnect();
      previewObserver = new IntersectionObserver(
        (entries) => {
          if (previewPlaybackLocked && activePreviewCard) {
            const activeVideo = activePreviewCard.querySelector('.c-reel-card__preview-video');
            if (activeVideo instanceof HTMLVideoElement && !activeVideo.paused && !activeVideo.ended) {
              return;
            }
          }

          const visible = entries
            .filter((entry) => entry.isIntersecting)
            .sort((a, b) => b.intersectionRatio - a.intersectionRatio);

          if (!visible.length) {
            pauseAllPreviews();
            return;
          }

          playPreviewForCard(visible[0].target);
        },
        {
          root: track,
          threshold: [0.35, 0.55, 0.75],
        }
      );

      cards.forEach((card) => previewObserver.observe(card));
    };

    const updateProgress = () => {
      if (!progressBar) return;
      const maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll <= 0) {
        progressBar.style.width = '100%';
        return;
      }
      const pct = (Math.abs(track.scrollLeft) / maxScroll) * 100;
      progressBar.style.width = `${Math.min(100, Math.max(4, pct))}%`;
    };

    const getSlides = () => [...track.querySelectorAll('.c-reel-card')];

    const getStep = () => {
      const slides = getSlides();
      if (slides.length < 2) return track.clientWidth;
      const a = slides[0].getBoundingClientRect();
      const b = slides[1].getBoundingClientRect();
      return Math.abs(b.left - a.left) || a.width || track.clientWidth;
    };

    const moveTrack = (intent) => {
      const rtl = document.documentElement.dir === 'rtl';
      const sign = (intent === 'next' ? 1 : -1) * (rtl ? -1 : 1);
      track.scrollBy({ left: sign * getStep(), behavior: 'smooth' });
    };

    const updateNavButtons = () => {
      if (!prevBtn || !nextBtn) return;

      const maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll <= 4) {
        prevBtn.disabled = true;
        nextBtn.disabled = true;
        return;
      }

      const pos = Math.abs(track.scrollLeft);
      prevBtn.disabled = pos <= 4;
      nextBtn.disabled = pos >= maxScroll - 4;
    };

    const onTrackScroll = () => {
      updateProgress();
      updateNavButtons();
    };

    let isDown = false;
    let dragMoved = false;
    let startX = 0;
    let startScroll = 0;

    const endDrag = () => {
      if (!isDown) return;
      isDown = false;
      track.classList.remove('is-dragging');
      requestAnimationFrame(() => {
        track.style.scrollSnapType = '';
      });
    };

    const resetModalVideo = () => {
      if (!modalVideo) return;
      modalVideo.pause();
      modalVideo.removeAttribute('src');
      modalVideo.innerHTML = '';
      modalVideo.load();
    };

    const closeModal = () => {
      if (!modal?.open) return;
      resetModalVideo();
      modal.close();
      document.documentElement.classList.remove('c-reels-modal-open');
      initPreviewAutoplay();
    };

    const openModal = async (button) => {
      if (!modal || !modalVideo) return;

      const videoUrl = pickReelVideoUrl(button);
      if (!videoUrl) return;

      pauseAllPreviews();
      previewObserver?.disconnect();

      resetModalVideo();
      modalVideo.src = videoUrl;
      modalVideo.load();

      const author = button.dataset.reelAuthor || '';
      const quote = button.dataset.reelQuote || '';
      if (modalMeta && modalAuthor && modalQuote) {
        const hasMeta = author !== '' || quote !== '';
        modalMeta.hidden = !hasMeta;
        modalAuthor.textContent = author;
        modalQuote.textContent = quote;
      }

      document.documentElement.classList.add('c-reels-modal-open');
      modal.showModal();

      if (modalVideo.readyState >= 2) {
        await playModalVideo(modalVideo);
      } else {
        modalVideo.addEventListener(
          'loadeddata',
          () => {
            playModalVideo(modalVideo);
          },
          { once: true }
        );
      }
    };

    prevBtn?.addEventListener('click', () => moveTrack('prev'));
    nextBtn?.addEventListener('click', () => moveTrack('next'));

    track.addEventListener('scroll', onTrackScroll, { passive: true });
    window.addEventListener('resize', () => {
      updateProgress();
      updateNavButtons();
      initPreviewAutoplay();
    });

    track.addEventListener('mousedown', (event) => {
      isDown = true;
      dragMoved = false;
      track.classList.add('is-dragging');
      startX = event.clientX;
      startScroll = track.scrollLeft;
      track.style.scrollSnapType = 'none';
    });

    window.addEventListener('mouseup', endDrag);
    track.addEventListener('mouseleave', endDrag);

    track.addEventListener('mousemove', (event) => {
      if (!isDown) return;
      if (Math.abs(event.clientX - startX) > 4) dragMoved = true;
      event.preventDefault();
      track.scrollLeft = startScroll - (event.clientX - startX);
    });

    section.addEventListener('click', (event) => {
      const wasDragging = dragMoved;
      dragMoved = false;
      if (wasDragging) return;

      const button = event.target.closest('[data-c-reel-open]');
      if (!button) return;
      event.preventDefault();
      openModal(button);
    });

    modal?.addEventListener('click', (event) => {
      if (event.target === modal) closeModal();
    });

    modal?.querySelectorAll('[data-c-reels-close]').forEach((button) => {
      button.addEventListener('click', closeModal);
    });

    modal?.addEventListener('cancel', (event) => {
      event.preventDefault();
      closeModal();
    });

    updateProgress();
    updateNavButtons();
    initPreviewAutoplay();
  };

  initCReviews(document);
  document.addEventListener('shopify:section:load', (event) => initCReviews(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-reviews-gallery"] && !Shopify.designMode) return;
  try {
    
  const initCRevGallery = (root) => {
    const section = root.matches?.('[data-c-rev-gallery]')
      ? root
      : root.querySelector?.('[data-c-rev-gallery]');
    if (!section || section.dataset.cRevReady === 'true') return;

    const lightbox = section.querySelector('[data-c-rev-lightbox]');
    if (!lightbox) {
      section.dataset.cRevReady = 'true';
      return;
    }
    section.dataset.cRevReady = 'true';

    const img = lightbox.querySelector('[data-c-rev-lightbox-img]');

    const close = () => {
      if (!lightbox.open) return;
      lightbox.close();
      if (img) {
        img.src = '';
        img.alt = '';
      }
    };

    section.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-c-rev-zoom]');
      if (!trigger || !img) return;
      img.src = trigger.dataset.src || '';
      img.alt = trigger.dataset.alt || '';
      lightbox.showModal();
    });

    lightbox.addEventListener('click', (event) => {
      if (event.target === lightbox) close();
    });
    lightbox.querySelector('[data-c-rev-lightbox-close]')?.addEventListener('click', close);
    lightbox.addEventListener('cancel', (event) => {
      event.preventDefault();
      close();
    });
  };

  initCRevGallery(document);
  document.addEventListener('shopify:section:load', (event) => initCRevGallery(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
